import React from "react";
import PageLayout from "@/components/PageLayout";
import { AlertTriangle, Info, Shield, CheckCircle, FileText } from 'lucide-react';
import { Helmet } from "react-helmet";

const Terms: React.FC = () => {
  return (
    <>
    <Helmet>
    <title>Mopaossi | Services</title>
    <meta
      name="description"
      content="Développeur Frontend | No-code| Low-code | UI/UX | Agilité"
    />
    <meta property="og:title" content="Mopaossi | Développeur Créatif" />
    <meta
      property="og:description"
      content="Découvrer un créateur, digitalisation, tech, app, dev : Mes sujets préférés."
    />
    <meta property="og:type" content="website" />
    <link rel="canonical" href="https://cbenji.pages.dev" />
  </Helmet>
    <PageLayout
      title="Conditions d'utilisation | Mopaossi"
      description="Conditions générales d'utilisation du site."
    >
      <div className="container mx-auto py-12 px-4">
        <div className="prose max-w-none">
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8 rounded-r">
            <div className="flex items-center">
              <Info className="h-6 w-6 text-blue-500 mr-3" />
              <p className="text-blue-700 font-medium">
                Ces conditions d'utilisation ont été mises à jour le 1 mai 2025.
              </p>
            </div>
          </div>
          
          <p className="lead">
            Bienvenue sur le site web de Mopaossi. En accédant à ce site, vous
            acceptez d'être lié par ces conditions d'utilisation, toutes les lois
            et réglementations applicables, et vous acceptez que vous êtes
            responsable du respect des lois locales applicables. Si vous
            n'acceptez pas ces conditions, veuillez ne pas utiliser ce site.
          </p>

          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 my-6 rounded-r">
            <div className="flex">
              <AlertTriangle className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0" />
              <div>
                <p className="text-amber-700 font-medium">Avertissement important</p>
                <p className="text-amber-600">
                  L'utilisation de ce site est soumise à l'acceptation complète des présentes conditions. Veuillez les lire attentivement.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            1. Utilisation de la licence
          </h2>
          <p>
            La permission est accordée de télécharger temporairement une copie des
            documents (informations ou logiciels) sur le site web pour un
            visionnement transitoire personnel et non commercial uniquement. Ceci
            est l'octroi d'une licence, non un transfert de titre, et sous cette
            licence, vous ne pouvez pas :
          </p>
          <ol className="my-4 mx-16 list-decimal">
            <li>
              utiliser les documents à des fins commerciales ou pour une
              présentation publique (commerciale ou non commerciale) ;
            </li>
            <li>
              tenter de décompiler ou de désosser tout logiciel contenu sur le
              site web sans en être un contributeur ;
            </li>
            <li>
              supprimer tout droit d'auteur ou autres annotations de propriété des
              documents ;
            </li>
          </ol>
          
          <div className="bg-slate-50 border border-slate-200 shadow-sm p-4 my-6 rounded-lg">
            <div className="flex">
              <FileText className="h-6 w-6 text-slate-500 mr-3 flex-shrink-0" />
              <div>
                <p className="text-slate-700 font-medium">Résiliation de licence</p>
                <p className="text-slate-600">
                  Cette licence sera automatiquement résiliée si vous violez l'une de
                  ces restrictions et peut être résiliée à tout moment.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            2. Avis de non-responsabilité
          </h2>
          <p>
            Les documents sur le site web sont fournis "tels quels". L'auteur ne
            donne aucune garantie, expresse ou implicite, et décline et annule par
            la présente toutes les autres garanties, y compris, sans limitation,
            les garanties implicites ou les conditions de qualité marchande,
            d'adéquation à un usage particulier, ou de non-violation de la
            propriété intellectuelle ou autre violation des droits.
          </p>
          
          <div className="bg-red-50 border-l-4 border-red-500 p-4 my-6 rounded-r">
            <div className="flex">
              <AlertTriangle className="h-6 w-6 text-red-500 mr-3 flex-shrink-0" />
              <div>
                <p className="text-red-700 font-medium">Limitation de garantie</p>
                <p className="text-red-600">
                  En outre, Mopaossi ne garantit ni ne fait aucune représentation concernant
                  l'exactitude, les résultats probables, ou la fiabilité de
                  l'utilisation des documents sur son site web ou autrement liés à ces
                  documents ou sur tout site lié à ce site.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Limitations</h2>
          <p>
            En aucun cas, Mopaossi ou ses fournisseurs ne seront responsables de tout
            dommage (y compris, sans limitation, les dommages pour perte de
            données ou de profit, ou en raison d'une interruption d'activité)
            découlant de l'utilisation ou de l'incapacité d'utiliser les documents
            sur le site web, même si l'auteur ou un représentant autorisé a été
            informé oralement ou par écrit de la possibilité de tels dommages.
            Comme certaines juridictions n'autorisent pas les limitations sur les
            garanties implicites, ou les limitations de responsabilité pour les
            dommages consécutifs ou accessoires, ces limitations peuvent ne pas
            s'appliquer à vous.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Révisions</h2>
          <p>
            Les documents apparaissant sur le site web peuvent inclure des erreurs
            techniques. L'auteur ne garantit pas que les documents de son site web
            sont exacts, complets ou à jour. Il peut modifier les documents
            contenus sur son site web à tout moment sans préavis et ne s'engage à
            mettre à jour les documents que si nécessaire.
          </p>

          <div className="bg-purple-50 border-l-4 border-purple-500 p-4 my-6 rounded-r">
            <div className="flex">
              <Info className="h-6 w-6 text-purple-500 mr-3 flex-shrink-0" />
              <p className="text-purple-700 text-sm italic">
                Important : Nous nous efforçons de maintenir le contenu à jour, mais des erreurs peuvent subsister. Nous vous recommandons de vérifier régulièrement les mises à jour.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Liens</h2>
          <p>
            L'auteur examine tous les sites liés à son site web et n'est pas
            responsable du contenu des sites non liés. L'inclusion de tout lien
            implique l'approbation de l'auteur. L'utilisation de tout site web non
            lié est aux risques et périls de l'utilisateur.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            6. Modifications des conditions d'utilisation du site
          </h2>
          
          <div className="bg-green-50 border-l-4 border-green-500 p-4 my-6 rounded-r">
            <div className="flex">
              <CheckCircle className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" />
              <div>
                <p className="text-green-700 font-medium">Mises à jour des conditions</p>
                <p className="text-green-600">
                  Nous nous réservons le droit de modifier ces conditions à tout moment. Votre utilisation continue du site après toute modification constitue votre acceptation des nouvelles conditions.
                </p>
              </div>
            </div>
          </div>
          
          <p>
            L'auteur peut réviser ces conditions d'utilisation de son site web à
            tout moment sans préavis. En utilisant ce site web, vous acceptez
            d'être lié par la version actuelle de ces conditions d'utilisation.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Loi applicable</h2>
          <p>
            Toute réclamation relative au site web de l'auteur sera régie par les
            lois en vigueur sur le territoire concerné.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            8. Politique de confidentialité
          </h2>
          
          <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4 my-6 rounded-r">
            <div className="flex">
              <Shield className="h-6 w-6 text-indigo-500 mr-3 flex-shrink-0" />
              <div>
                <p className="text-indigo-700 font-medium">Protection de vos données</p>
                <p className="text-indigo-600">
                  Nous prenons la protection de vos données personnelles au sérieux. Notre politique de confidentialité détaille comment nous collectons, utilisons et protégeons vos informations.
                </p>
              </div>
            </div>
          </div>
          
          <p>
            Votre vie privée est importante pour nous. Veuillez consulter notre{" "}
            <a
              href="/security"
              className="text-blue-600 hover:link-fancy relative after:absolute after:bg-blue-600 after:bottom-0 after:left-0 after:h-[2px] after:w-full after:origin-bottom-right after:scale-x-0 hover:after:origin-bottom-left hover:after:scale-x-100 after:transition-transform after:ease-in-out after:duration-300"
            >
              Politique de confidentialité
            </a>
            , qui fait également partie de ces conditions d'utilisation.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            9. Conditions générales
          </h2>
          <p>
            Si une disposition de ces conditions d'utilisation est jugée
            inapplicable ou invalide, cette disposition sera limitée ou éliminée
            dans la mesure minimale nécessaire pour que les conditions
            d'utilisation restent par ailleurs pleinement en vigueur et
            applicables. Ces conditions d'utilisation constituent l'intégralité de
            l'accord entre l'auteur et vous concernant l'utilisation du site.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">10. Contact</h2>
          
          <div className="bg-blue-50 border border-blue-200 shadow-sm p-4 my-6 rounded-lg">
            <div className="flex">
              <Info className="h-6 w-6 text-blue-500 mr-3 flex-shrink-0" />
              <div>
                <p className="text-blue-700 font-medium">Besoin d'aide ?</p>
                <p className="text-blue-600">
                  Si vous avez des questions ou des préoccupations concernant ces conditions d'utilisation, n'hésitez pas à nous contacter.
                </p>
              </div>
            </div>
          </div>
          
          <p>
            Si vous avez des questions concernant ces conditions d'utilisation,
            veuillez nous contacter par le lien <a
              href="/contact"
              className="text-blue-600 hover:link-fancy relative after:absolute after:bg-blue-600 after:bottom-0 after:left-0 after:h-[2px] after:w-full after:origin-bottom-right after:scale-x-0 hover:after:origin-bottom-left hover:after:scale-x-100 after:transition-transform after:ease-in-out after:duration-300"
            >
              Contact
            </a>.
          </p>
          <p>Date de dernière mise à jour : 1 mai 2025</p>
        </div>
      </div>
    </PageLayout>
    </>
  );
};

export default Terms;